import { render, staticRenderFns } from "./CommunityMin.vue?vue&type=template&id=1cc5459f&scoped=true&"
import script from "./CommunityMin.vue?vue&type=script&lang=js&"
export * from "./CommunityMin.vue?vue&type=script&lang=js&"
import style0 from "./CommunityMin.vue?vue&type=style&index=0&id=1cc5459f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5459f",
  null
  
)

export default component.exports